/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
export class GmPerson {
  gmPersonID: number;
  badgeID: string;
  employeeTypeId: number;
  department: string;
  company: string;
  namePrefix: string;
  identificationId: string;
    personID: number;
    firstName: string;
    middleName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
  preferredName:string;
}
